export const metersPerSecondToMinutesPerMile = (mps: number) => 26.8224 / mps
export const metersToMiles = (m: number) => m / 1609
export const metersToFeet = (m: number) => m * 3.281
export const formatMilesDistance = (miles: number) => miles.toFixed(2) + ' mi'
